import { PlusIcon } from '@heroicons/react/16/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { LockPill } from '../../../../components/pricing/lock-badge'
import SampleBadge from '../../../../components/sample-data/sample-badge'
import Button from '../../../../components/tailwind/Button'
import { Heading } from '../../../../components/ui/Heading'
import { truncateCareerID } from '../../../../helpers'
import TalentBadge from './TalentBadge'

/**
 * Molecule Component: TalentComboboxOption
 * Displays a talent option in the combobox with add button
 */
const TalentComboboxOption = ({ talent, onAdd, focus = false }) => {
  const { t } = useTranslation()
  const displayName = talent.name || talent.email || String(talent.id)
  const truncatedName =
    displayName.length > 40 ? displayName.slice(0, 37) + '...' : displayName

  return (
    <div
      className={clsx(
        'flex items-center justify-between px-4 py-3',
        focus ? 'bg-gray-50' : ''
      )}
    >
      <div className='flex items-center space-x-3'>
        <TalentBadge name={displayName} />
        <div>
          <div className='flex items-center space-x-1'>
            <Heading level={5} title={displayName}>
              {truncatedName}
            </Heading>
            {talent.isDemo && <SampleBadge kind='talent' />}
            {/* Gesperrt im Talentspeicher, sichtbar, aber nicht auswählbar */}
            {talent.isLocked && (
              <span title={t('pricing.talent_locked.row_sr')}>
                <LockPill label={t('pricing.talent_locked.placeholder')} />
              </span>
            )}
          </div>
          {displayName !== String(talent.id) && (
            <div className='text-sm text-gray-500' title={String(talent.id)}>
              {truncateCareerID(String(talent.id))}
            </div>
          )}
        </div>
      </div>
      <div className='flex items-center space-x-2'>
        <div onClick={(e) => e.stopPropagation()}>
          <Button.SecondaryLG
            text='Hinzufügen'
            icon={<PlusIcon className='size-4 text-buttonSecondaryBlue' />}
            onClick={() => !talent.isLocked && onAdd(talent)}
            disabled={!!talent.isLocked}
          />
        </div>
      </div>
    </div>
  )
}

TalentComboboxOption.propTypes = {
  talent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    isDemo: PropTypes.bool,
    isLocked: PropTypes.bool
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  focus: PropTypes.bool
}

export default TalentComboboxOption
